import { Box, CircularProgress, Divider, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat, notaToPonderacionHelper } from '../../../../../../helpers';
import { allEstudiantesNotasEvaluativasAction } from '../../../../estudiantes/EstudiantesAction';
import CardEstudiantesReprobados from './CardEstudiantesReprobados';
import ChartEstudiantePlanEvaluacion from './ChartEstudiantePlanEvaluacion';

export const getterReprobados = (
  tipoSearch,
  planEvaluacion,
  entidadPonderacion,
  all,
) => {
  const instrumentos = [];
  planEvaluacion.temas.forEach((t) => {
    t.evaluaciones.forEach((e) => {
      e.instrumentos.forEach((i) => instrumentos.push(i));
    });
  });

  return all.filter((est) => {
    if (est.notasEvaluativas.length > 0) {
      // POR NOTAS
      if (tipoSearch === 1) {
        const notasBajas = [];
        instrumentos.forEach((i) => {
          const notaEva = est.notasEvaluativas.find(
            (n) => n.ptevaInstrumento.id === i.id,
          );
          if (parseInt(notaEva?.nota) < 10)
            notasBajas.push(notaEva?.nota ?? '00');
        });
        return notasBajas.length > 0;
      }

      // POR DEFINITIVA
      if (tipoSearch === 2) {
        let puntos = 0;

        instrumentos.forEach((i) => {
          const nota = est.notasEvaluativas.find(
            (notaEva) => notaEva.ptevaInstrumento.id === i.id,
          );

          let actExtra = est.actividadesExtras.find(
            (a) =>
              a.actividadExtra?.ptevaInstrumento?.id === i.id &&
              a.actividadExtra.tipo === 'RECUPERACION' &&
              a.actividadExtra.planEvaluacion.id === planEvaluacion?.id,
          );

          if (actExtra) {
            puntos =
              puntos +
              notaToPonderacionHelper(
                parseInt(actExtra.nota),
                actExtra.ponderacion,
                entidadPonderacion,
              );
            return;
          }

          if (nota) {
            puntos =
              puntos +
              notaToPonderacionHelper(
                parseInt(nota.nota),
                nota.ponderacion,
                entidadPonderacion,
              );
          }
        });

        if (Math.round(puntos) < 10) {
          est.definitiva = Math.round(puntos);
          return true;
        }
      }
    }
    return false;
  });
};

const EstadisticasPlanEvaluacion = ({ num }) => {
  const dispatch = Redux.useDispatch();

  const templateStore = Redux.useSelector((state) => state.template);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);

  const [tipoSearch, setTipoSearch] = React.useState(1);
  const [reprobados, setReprobados] = React.useState([]);
  const [instrumentos, setInstrumentos] = React.useState([]);
  const [loadingIns, setLoadingIns] = React.useState(true);

  React.useEffect(() => {
    async function fetchData() {
      setInstrumentos([]);
      if (estudiantesStore.allEstudiantesNotas.length === 0) {
        await allEstudiantesNotasEvaluativasAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
          idPeriodoAcademico:
            planEvaluacionStore.activo.fechaBloque.periodoAcademico.id,
          idPlanEvaluacion: planEvaluacionStore.activo.id,
        });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getterPlan() {
    setInstrumentos([]);
    const actividadesArray = [];
    planEvaluacionStore.activo.temas.forEach((t) => {
      t.evaluaciones.forEach((e) => {
        e.instrumentos.forEach((i) => {
          actividadesArray.push({ ...i, reprobados: 0 });
        });
      });
    });
    setInstrumentos(actividadesArray);

    const reprobadosArray = getterReprobados(
      tipoSearch,
      planEvaluacionStore.activo,
      entidadesStore.ajustes.ponderacion,
      estudiantesStore.allEstudiantesNotas,
    );
    setReprobados(reprobadosArray);
    setTimeout(() => setLoadingIns(false), 500);
  }

  React.useEffect(() => {
    getterPlan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estudiantesStore.allEstudiantesNotas]);

  React.useEffect(() => {
    setLoadingIns(true);
    getterPlan();
    setTimeout(() => setLoadingIns(false), 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoSearch]);

  const tipoNotas = instrumentos.map((el) => {
    let estudiantes = [];
    reprobados.forEach((est) => {
      const notaEva = est.notasEvaluativas.find(
        (n) => n.ptevaInstrumento.id === el.id,
      );

      if (notaEva && parseInt(notaEva.nota) < 10) {
        estudiantes.push({ ...est, nota: notaEva.nota });
      }
    });

    return (
      <Box
        key={el.id}
        align="center"
        sx={{
          fontWeight: 'bold',
          fontSize: 18,
          mr: 1,
          backgroundColor: '#f5f5f5',
          borderRadius: 2,
          py: 1,
          boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.5)',
        }}
      >
        <Typography variant="body1" fontWeight="bold" color="initial">
          {el.instrumento.nombre}
        </Typography>
        <Typography variant="body1" color="initial">
          {dateformat(el.fechaInicio, {
            inverse: true,
          })}{' '}
          / {el.ponderacion} Pts.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            fontWeight: 'normal',
            width: '350px',
            minHeight: '210px',
            maxHeight: '70vh',
            backgroundColor: '#e7e7e7',
            pt: 1,
            flexWrap: 'wrap',
            justifyContent: 'space-evenly',
            borderRadius: 2,
            overflowY: 'scroll',
            mb: 3,
          }}
        >
          {estudiantes.map((estudiante) => (
            <CardEstudiantesReprobados
              key={estudiante.id}
              tipoSearch={1}
              estudiante={estudiante}
            />
          ))}
        </Box>
      </Box>
    );
  });

  return num === 1 ? (
    loadingIns ? (
      <CircularProgress size="50px" />
    ) : (
      <div>
        <Stack direction="row" alignItems="center">
          {/* <FormControl sx={{ width: '200px', mr: 2 }} size="small">
            <InputLabel id={`label_tipo`}>Tipo de búsqueda</InputLabel>
            <Select
              id="tipo-select"
              value={tipoSearch}
              labelId={`label_tipo`}
              required
              label="Tipo de búsqueda"
              onChange={(e) => {
                setTipoSearch(e.target.value);
              }}
            >
              <MenuItem value={1}>NOTAS</MenuItem>
              <MenuItem value={2}>DEFINITIVA</MenuItem>
            </Select>
          </FormControl> */}

          <Typography variant="h6" color="initial">
            Estudiantes reprobados por actividad
          </Typography>
        </Stack>
        <Divider sx={{ my: 1 }} />

        {tipoSearch === 1 ? (
          <Stack
            direction="row"
            sx={{
              width: templateStore.settings.openSidebar ? '73vw' : '90vw',
              overflowX: 'scroll',
            }}
          >
            {tipoNotas}
          </Stack>
        ) : (
          <Grid
            container
            spacing={1}
            sx={{
              backgroundColor: '#e7e7e7',
            }}
          >
            {reprobados.map((est) => (
              <Grid item xs={12} md={3}>
                <CardEstudiantesReprobados
                  key={est.id}
                  estudiante={est}
                  tipoSearch={2}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </div>
    )
  ) : (
    <Grid container spacing={1}>
      {loadingIns ? (
        <CircularProgress size="50px" />
      ) : (
        <Box sx={{ width: '100%' }}>
          <ChartEstudiantePlanEvaluacion
            instrumentos={instrumentos}
            estudiantes={estudiantesStore.allEstudiantesNotas}
          />
        </Box>
      )}
    </Grid>
  );
};

export default EstadisticasPlanEvaluacion;
